<script setup lang="ts"></script>

<template>
  <div role="status" class="animate-pulse">
    <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
  </div>
</template>
